import * as userInfoActions from '../constants/userInfo'

const initialState = {}

export function userInfo(state = initialState, actions) {
    switch (actions.type) {
        case userInfoActions.GET_USERINFO:
            return actions.user
        case userInfoActions.UPDATE_USERINFO:
            return actions.user
        default:
            return state
    }
}
